import { useMemo, useState } from 'react'

import { splitDomain } from '@modules/Dashboard/pages/Settings/pages/Domain/modules/ClaimDomain/utils/splitDomain'

import { useGetSuggestionsQuery } from '../queries/useGetSuggestionsQuery'

export const useSearchDomain = () => {
  const [search, setSearch] = useState('')

  const mainDomain = useMemo(() => {
    return splitDomain(search).mainDomain
  }, [search])

  const { getSuggestionsQuery } = useGetSuggestionsQuery([{ name: mainDomain }], {
    enabled: !!search,
    retry: false,
  })

  const handleSearch = (domain: string) => {
    if (domain.length && !domain.includes('.')) {
      setSearch(`${domain}.store`)

      return
    }

    setSearch(domain)
  }

  const suggestions = useMemo(() => {
    return (
      getSuggestionsQuery.data?.suggestions
        ?.filter((suggestion) => suggestion !== search)
        .slice(0, 5) || []
    )
  }, [search, getSuggestionsQuery.data])

  return {
    search,
    isDomainAvailable: getSuggestionsQuery.data?.suggestions?.includes(search),
    isSearching: getSuggestionsQuery.isInitialLoading,
    suggestions,
    setSearch: handleSearch,
  }
}
